import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CustomAutomationData } from '@fitness-force/models';
import { AngularQueryBuilderComponent } from '@fitness-force/shared';
import { TranslateModule } from '@ngx-translate/core';
import { ToastMessageService } from '@fitness-force/api';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageModule } from 'primeng/message';
import { StyleClassModule } from 'primeng/styleclass';


@Component({
  selector: 'fitness-force-rule-builder-popup',
  templateUrl: './rule-builder-popup.component.html',
  styleUrls: ['./rule-builder-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers:[ToastMessageService],
  standalone: true,
  imports: [
    CommonModule,
    StyleClassModule,
    MessageModule,
    ButtonModule, 
    AngularQueryBuilderComponent,
    TranslateModule
  ]
})
export class RuleBuilderPopupComponent implements OnInit {
  modelData:CustomAutomationData ={} as CustomAutomationData;
  eventType:string="";
  rule:string="";
  sqlRule:string="";
  
  constructor(
    private ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private cd: ChangeDetectorRef,
  ) {
    if (this.config.data) {
      this.modelData = this.config.data;
      this.eventType = this.modelData.automationType!.toString()
    }
   }

  ngOnInit(): void {
  }

  useRule()
  {
    this.modelData.sqlRule= this.rule;
    this.modelData.sqlQuery = this.sqlRule;
    this.ref.close(this.modelData);
  }

  closePopup()
  {
    this.ref.close(this.modelData);
  }

  getRule(event: any) {
    console.log(event);
    //this.modelData.sqlRule= event;
    this.rule = event.rule;
    this.sqlRule= event.sqlRule;
  }

}